import { LineChart } from "@mui/x-charts/LineChart";
import { ChartCard } from "../../../components/charts/ChartCard";
import { CHART_COLORS, chartSx, formatRupees, formatRupeesAxis } from "../../../components/charts/chartTheme";
import { DailyFeeTrend } from "../types";

// Single series, so no legend: the card title names it.
export const DailyFeeTrendChart = ({ data }: { data: DailyFeeTrend[] }) => {
  return (
    <ChartCard title={`Daily Fee Collection – ${new Date().toLocaleDateString('en-US', { month: 'long' })}`}>
      <LineChart
        height={300}
        hideLegend
        dataset={data}
        xAxis={[{ scaleType: "point", dataKey: "day", disableTicks: true }]}
        yAxis={[{ width: 56, disableLine: true, disableTicks: true, valueFormatter: formatRupeesAxis }]}
        series={[
          { dataKey: "collected", label: "Collected", color: CHART_COLORS.series1, area: true, curve: "monotoneX", showMark: false, valueFormatter: formatRupees },
        ]}
        grid={{ horizontal: true }}
        margin={{ top: 10, right: 20, bottom: 0, left: 0 }}
        sx={chartSx}
      />
    </ChartCard>
  );
};
